import { dispatch } from "../utils/dispatch";
import { map } from "../dispatchers";

dispatch.addMethod("fold", Promise, (self, success, failure) =>
  self.then(success).catch(failure)
);

dispatch.addMethod("flatten", Promise, self => self);

dispatch.addMethod("map", Promise, (self, f) => self.then(f));

dispatch.addMethod("mapError", Promise, (self, f) => self.catch(f));

dispatch.addMethod("flatMap", Promise, map);

dispatch.addMethod(
  "of",
  Promise,
  (_, x) => new Promise((succeed, fail) => (x == null ? fail() : succeed(x)))
);
